import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { fetchDispatchList } from 'apps/web_forms/slices/appSlice';
import { APP_ROUTES } from 'apps/web_forms/utils/constants';
import { useDispatch } from 'react-redux';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

function useDispatchesListQuery() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { dispatchList } = useGlobalSelector();
  const [dispatches, setDispatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    dispatch(fetchDispatchList());
  }, []);

  useEffect(() => {
    if (dispatchList.loading !== loading) {
      setLoading(dispatchList.loading);
    }

    if (dispatchList.data && dispatchList.data !== dispatches) {
      setDispatches(dispatchList.data);
    }

    if (dispatchList.error) {
      setError(dispatchList.error);
      // TODO: Integrate Bugsnag to log the errors in prod.
      // eslint-disable-next-line no-console
      console.error('Error fetching dispatches', dispatchList.error);
      history.push(APP_ROUTES.getErrorPageByCode(500));
    }
  }, [dispatchList]);

  return { dispatches, loading, error };
}

export default useDispatchesListQuery;
export { useDispatchesListQuery };
